import type { CSSProperties } from "react";

/**
 * Resolve flex CSS properties from group width hint.
 * @param width - Width hint (percent, pixels, or flex weight)
 * @returns CSS flex properties
 */
export function resolveGroupFlex(width: string | undefined): CSSProperties {
  if (!width) return { flex: "1 1 0", minWidth: 0 };

  const numeric = parseFloat(width);

  if (width.endsWith("%") && numeric > 100) {
    const weight = numeric / 100;
    return { flex: `${weight} 1 0`, minWidth: 0 };
  }

  return { flex: `0 0 ${width}`, maxWidth: width, minWidth: 0 };
}

/**
 * Resolve CSS width properties from item width hint.
 * @param width - Width value (CSS units)
 * @returns CSS width/flex-basis properties
 */
export function resolveItemWidth(width: string | undefined): CSSProperties {
  if (!width) return {};
  // If width is percentage-based, allow it to shrink
  if (width.trim().endsWith("%")) {
    return { flex: `1 1 0`, minWidth: 0, width };
  }

  return { flex: `0 0 ${width}`, maxWidth: width };
}
